export class User {
    name: string = "";
    phone_no: string = "";
    nation: string = "";
    gender: string = "";
    email: string = "";
    dateofbirth: string = "";
    password: string = "";
}
